module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('data-form', {
    attrs: {
      "model": "users",
      "entity": _vm.currentUser,
      "fields": _vm.fields,
      "after-submit": _vm.afterSubmit,
      "cancel": false
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33da860b!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/setup-guide/AdminModification.vue
// module id = 1141
// module chunks = 2